import { createAction } from 'redux-actions';

export const articleFetch = createAction('ARTICLE_DETAILS_PAGE_ARTICLE_FETCH');
export const articleSet = createAction('ARTICLE_DETAILS_PAGE_ARTICLE_SET');
